import React, { ComponentType, memo } from 'react'

import { InputPlaceholder } from './InputPlaceholder'
import { InputText } from './InputText'
import { BaseOptionType } from './types'

export interface IBaseSelectInputProps<Option> {
  getOptionName: (o?: Option) => string
  placeholder: string
  selectedOptions: Option | Option[] | undefined
  Icon?: ComponentType<ISvgIconProps>
  isDisabled?: boolean
  isEmptyOptions?: boolean
  isOpen?: boolean
  selectPlaceholderClassName?: string
  selectTextClassName?: string
  testId?: string
}

const BaseSelectInputNoMemo = <Option extends BaseOptionType>({
  placeholder,
  selectTextClassName,
  selectPlaceholderClassName,
  Icon,
  selectedOptions,
  getOptionName,
  testId
}: IBaseSelectInputProps<Option>) => {
  const selectText = Array.isArray(selectedOptions) ? getOptionName(selectedOptions[0]) : getOptionName(selectedOptions)

  if (selectText) {
    return (
      <InputText Icon={Icon} className={selectTextClassName} testId={testId}>
        {selectText}
      </InputText>
    )
  }

  return (
    <InputPlaceholder Icon={Icon} className={selectPlaceholderClassName}>
      {placeholder}
    </InputPlaceholder>
  )
}

export const BaseSelectInput = memo(BaseSelectInputNoMemo) as typeof BaseSelectInputNoMemo
